import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class SchoolService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SCHOOL_UPDATE(
          $id: String!
          $data: SchoolInput!
          $manage: ManageInput!
        ) {
          schoolUpdate(
            id: $id
            data: $data
            manage: $manage
          ) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.schoolUpdate;
  }

  static async destroyAll(ids, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SCHOOL_DESTROY(
          $ids: [String!]!
          $subpropertyId: String!
        ) {
          schoolDestroy(
            ids: $ids
            subpropertyId: $subpropertyId
          )
        }
      `,

      variables: {
        ids,
        subpropertyId,
      },
    });

    return response.data.schoolDestroy;
  }

  static async create(data, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SCHOOL_CREATE(
          $data: SchoolInput!
          $subpropertyId: SchoolInput!
        ) {
          schoolCreate(
            data: $data
            subpropertyId: $subpropertyId
          ) {
            id
          }
        }
      `,

      variables: {
        data,
        subpropertyId,
      },
    });

    return response.data.schoolCreate;
  }

  static async import(values, importHash, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SCHOOL_IMPORT(
          $data: SchoolInput!
          $importHash: String!
          $subpropertyId: String!
        ) {
          schoolImport(
            data: $data
            importHash: $importHash
            subpropertyId: $subpropertyId
          )
        }
      `,

      variables: {
        data: values,
        importHash,
        subpropertyId,
      },
    });

    return response.data.schoolImport;
  }

  static async find(id, subpropertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query SCHOOL_FIND(
          $id: String!
          $subpropertyId: String!
        ) {
          schoolFind(
            id: $id
            subpropertyId: $subpropertyId
          ) {
            id
            name
            location {
              url
              name
              information
              latitude
              longitude
            }
            teams {
              id
              name
              program {
                id
                name
              }
              subprogram {
                id
                name
              }
            }
            coaches {
              id
              email
            }
            subprograms {
              id
              name
            }
            updatedAt
            createdAt
          }
        }
      `,

      variables: {
        id,
        subpropertyId,
      },
    });
    
    return response.data.schoolFind;
  }

  static async list(
    filter,
    orderBy,
    limit,
    offset,
    subpropertyId,
  ) {
    const response = await graphqlClient.query({
      query: gql`
        query SCHOOL_LIST(
          $filter: SchoolFilterInput
          $orderBy: SchoolOrderByEnum
          $limit: Int
          $offset: Int
          $subpropertyId: String!
        ) {
          schoolList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            subpropertyId: $subpropertyId
          ) {
            count
            rows {
              id
              name
              location {
                url
                name
                information
                latitude
                longitude
              }
              teams {
                id
                name
                program {
                  id
                  name
                }
                subprogram {
                  id
                  name
                }
              }
              coaches {
                id
                email
              }
              subprograms {
                id
                name
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        subpropertyId,
      },
    });

    return response.data.schoolList;
  }

  static async listAutocomplete(
    query,
    limit,
    subpropertyId,
  ) {
    const response = await graphqlClient.query({
      query: gql`
        query SCHOOL_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $subpropertyId: Int
        ) {
          schoolAutocomplete(
            query: $query
            limit: $limit
            subpropertyId: $subpropertyId
          ) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        subpropertyId,
      },
    });

    return response.data.schoolAutocomplete;
  }
}
